import DocumentSpreadsheetCrud from "../components/document/DocumentSpreadsheetCrud";

const DocumentSpreadsheetPage = () => {
  return (
    <>
      <DocumentSpreadsheetCrud />
    </>
  );
};

export default DocumentSpreadsheetPage;
